import { IntlFormatters } from 'react-intl';

import Joi from 'joi';
import { complexPassword } from '@marketplace/common';

export const resetPassowrdValidationSchema = ({
    formatMessage,
  }: Pick<IntlFormatters, 'formatMessage'>) => {
  const passwordLabel = formatMessage({
    id: 'developer_personal_page_personal_profile_password'
  });

  const confirmPasswordLabel = formatMessage({
    id: 'developer_personal_page_personal_profile_password'
  });
  
  return Joi.object({
        password: Joi.string().trim().required().min(14).max(200)
        // eslint-disable-next-line
        .pattern(/^[A-Za-z0-9_~!@#$%^&*()\-=+\[\]{}|]+$/)
        .custom(complexPassword({
        lowerCase: 1,
        upperCase: 1,
        numeric: 1,
        symbol: 1,
        })).messages({
        'string.pattern.base': formatMessage({ id: 'generalForm_validation_allowed' }, { field: passwordLabel }),
        'string.empty': formatMessage({ id: 'generalForm_validation_required' }, { field: passwordLabel }),
        'string.min': formatMessage({ id: 'generalForm_validation_range' }, { field: passwordLabel, min: 14, max: 200 }),
        'string.lowerCase': formatMessage({ id: 'generalForm_validation_lowerCase' }, { field: passwordLabel, lowerCase: 1 }),
        'string.upperCase': formatMessage({ id: 'generalForm_validation_upperCase' }, { field: passwordLabel, upperCase: 1 }),
        'string.numeric': formatMessage({ id: 'generalForm_validation_numeric' }, { field: passwordLabel, numeric: 1 }),
        'string.symbol': formatMessage({ id: 'generalForm_validation_symbol' }, { field: passwordLabel, symbol: 1 }),
        }),

        confirmPassword: Joi.any().required().valid(Joi.ref('password')).messages({
        'any.only': formatMessage({ id: 'generalForm_validation_confirmPassword' }, { field: confirmPasswordLabel }),
        }),
    });
  };